import { storableError } from '../util/errors';

// ================ Action types ================ //

export const SET_CREWS_ONBOARDING_COMPLETED = 'app/crewsOnboarding/SET_CREWS_ONBOARDING_COMPLETED';
export const MARK_CREWS_FIRST_VISIT_DONE = 'app/crewsOnboarding/MARK_CREWS_FIRST_VISIT_DONE';

// Add crew tracking functionality
export const JOIN_CREW = 'app/crewsOnboarding/JOIN_CREW';
export const LEAVE_CREW = 'app/crewsOnboarding/LEAVE_CREW';
export const SET_CREW_COUNT = 'app/crewsOnboarding/SET_CREW_COUNT';

// ================ Reducer ================ //

const initialState = {
  isFirstTimeVisit: true,
  onboardingCompleted: false,
  crewCount: 0, // Track number of crews user belongs to
};

export default function crewsOnboardingReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  let newState;

  switch (type) {
    case SET_CREWS_ONBOARDING_COMPLETED:
      newState = {
        ...state,
        onboardingCompleted: payload.completed,
        isFirstTimeVisit: false,
      };
      return newState;

    case MARK_CREWS_FIRST_VISIT_DONE:
      newState = {
        ...state,
        isFirstTimeVisit: false,
      };
      return newState;

    case JOIN_CREW:
      newState = {
        ...state,
        crewCount: state.crewCount + 1,
      };
      return newState;
    case LEAVE_CREW:
      newState = {
        ...state,
        crewCount: Math.max(0, state.crewCount - 1), // Ensure count doesn't go below 0
      };
      return newState;
    case SET_CREW_COUNT:
      newState = {
        ...state,
        crewCount: payload,
      };
      return newState;

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setCrewsOnboardingCompleted = (completed = true) => ({
  type: SET_CREWS_ONBOARDING_COMPLETED,
  payload: { completed },
});

export const markCrewsFirstVisitDone = () => ({
  type: MARK_CREWS_FIRST_VISIT_DONE,
});

// Add crew tracking functionality
export const joinCrew = () => ({ type: JOIN_CREW });
export const leaveCrew = () => ({ type: LEAVE_CREW });
export const setCrewCount = count => ({ type: SET_CREW_COUNT, payload: count });

// ================ Selectors ================ //

export const getCrewsOnboardingState = state => state.crewsOnboarding || initialState;

// Check if user has completed crews onboarding based on both Redux state and profile data
export const getIsFirstTimeCrewsVisit = (state, currentUser) => {
  // First check Redux state - if it's been marked as done, user has seen the modal
  if (!state.crewsOnboarding.isFirstTimeVisit) {
    return false;
  }

  // If Redux state says first time, also check user profile
  if (!currentUser || !currentUser.attributes || !currentUser.attributes.profile) {
    return true; // Default to first time visit if no user data
  }

  const profile = currentUser.attributes.profile;
  const publicData = profile.publicData || {};

  // Check if InCrews is set to true in user's profile
  return publicData.InCrews !== true;
};

export const getCrewsOnboardingCompleted = (state, currentUser) => {
  if (!currentUser || !currentUser.attributes || !currentUser.attributes.profile) {
    return false;
  }

  const profile = currentUser.attributes.profile;
  const publicData = profile.publicData || {};

  return publicData.InCrews === true;
};

// Selector to get crew count
export const getCrewCount = state => state.crewsOnboarding.crewCount;
